import axios from 'axios';
import { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useParams } from 'react-router-dom';
import swal from 'sweetalert';
import { BASE_URL, Image_URL } from '../../App';
import ScrollTopButton from '../ScrollTop';
import '../../styles/modelanswer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes, faLightbulb, faQuestion, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import BrianAnimated from '../BrainAnimated';

function ModelAnswerQuiz({ style }) {
  const [answer, setAnswer] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSticky, setIsSticky] = useState(false);

  const { id } = useParams();
useEffect(() => {
  window.scrollTo(0, 0);

  const fetchAnswer = async () => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    const config = { headers: { Authorization: `Bearer ${token}` } };

    const delay = new Promise(resolve => setTimeout(resolve, 2000)); // ⏱️ تأخير 3 ثوانٍ

    try {
      const responsePromise = axios.get(`${BASE_URL}/api/quiz-model-answer/${id}`, config);
      const [response] = await Promise.all([responsePromise, delay]);

      setAnswer(response.data.data);
    } catch (error) {
      handleApiError(error);
    } finally {
      setIsLoading(false);
    }
  };

  fetchAnswer();
}, [id]);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleApiError = (error) => {
    const status = error.response?.status;
    if (status === 468 || status === 469) {
      swal({
        title: "! برجاء الانتظار حتى ينتهي وقت الامتحان",
        text: "نتمنى لك أعلى الدرجات",
        icon: "warning",
        buttons: "الخروج",
      }).then(() => window.history.back());
    }
  };

  const getStats = () => {
    // const answeredQuestions = answer.filter(a => a.choosen !== null && a.choosen !== "0" && a.choosen !== 0);
    const answeredQuestions = answer.filter(a => a.choosen !== null );
        const correctAnswers = answeredQuestions.filter(a => a.choosen === a.answer).length;
    const wrongAnswers = answeredQuestions.filter(a => a.choosen !== a.answer).length;
    const notAnswered = answer.length - answeredQuestions.length;
    const totalDegreeOfAnswered = answeredQuestions.reduce((sum, q) => sum + parseInt(q.degree), 0);
    const score = answeredQuestions.reduce((sum, q) => q.choosen === q.answer ? sum + parseInt(q.degree) : sum, 0);
    const percentage = totalDegreeOfAnswered > 0 ? Math.round((score * 100) / totalDegreeOfAnswered) : 0;
    const totalPossibleDegree = answer.reduce((sum, q) => sum + parseInt(q.degree), 0);
    return {
      correctAnswers,
      wrongAnswers,
      notAnswered,
      totalDegree: totalPossibleDegree,
      score,
      percentage,
    };
  };

  const stats = getStats();
  
  const getProgressBarPathColor = (percentage) => {
    if (percentage < 50) return "#ef4444";
    if (percentage < 70) return "#f59e0b";
    if (percentage < 90) return "#f59e0b";
    return "#22c55e";
  };
  const getMotivationalData = (percentage) => {
    if (percentage < 50)
      return { message: "محتاج تشد شوية !", className: "fail" };
    if (percentage < 70)
      return {
        message: "نتيجة كويسة، بس أنت تقدر على الأحسن!",
        className: "good",
      };
    if (percentage < 90)
      return {
        message: "جامد وان شاء الله المرة الجاية تقفيل",
        className: "good",
      };
    return { message: "جامد وإن شاء الله هتبقي حاجة جامدة", className: "excellent" };
  };

  const motivationalData = getMotivationalData(stats.percentage);

  const scrollToQuestion = (questionId) => {
    const element = document.getElementById(`question-${questionId}`);
    if (element) {
      const offset = 120;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({ top: offsetPosition, behavior: "smooth" });
    }
  };

  const renderChoice = (props, choiceNumber, choiceText) => {
    const isCorrect = props.answer === choiceNumber;
    const isChosenWrong = props.choosen === choiceNumber && props.choosen !== props.answer;

    let indicatorIcon = null;
    if (isCorrect) {
      indicatorIcon = <FontAwesomeIcon icon={faCheck} />;
    } else if (isChosenWrong) {
      indicatorIcon = <FontAwesomeIcon icon={faTimes} />;
    }

    return (
      <div className={`choice-item ${isCorrect ? "correct-answer" : isChosenWrong ? "wrong-answer" : ""}`}>
        <span className="choice-indicator">{indicatorIcon}</span>
        <p>{choiceText}</p>
      </div>
    );
  };

  if (isLoading) {
     return (
 <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
        <div className="loading-course">
        <BrianAnimated  />
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`model-answer-page ${style ? "dark-mode" : ""}`}>
        <div className={`motivational-alert ${motivationalData.className} ${isSticky ? 'sticky' : ''}`}>{motivationalData.message}</div>
        <Container>
          <div className="results-header"><h1>الموديل <span>أنسر</span></h1></div>
          <div className="results-dashboard">
            <div className="main-score-card">
              <div style={{ width: "180px", height: "180px" }}>
                <CircularProgressbar value={stats.percentage} text={`${stats.percentage}%`} styles={buildStyles({ pathColor: getProgressBarPathColor(stats.percentage), textColor: style ? "#f9fafb" : "#111827", trailColor: style ? "rgba(255, 255, 255, 0.1)" : "#e5e7eb", pathTransitionDuration: 1.5, pathTransition: "stroke-dashoffset 1.5s ease-in-out", })} />
              </div>
              {/* <img src="/images/stubid.png" className='stubid' alt="logo" /> */}

              <div className="score-details"><h4>نتيجتك النهائية</h4><span>{stats.score}</span> / {stats.totalDegree}</div>
            </div>
            <div className="sub-stats-grid">
              <div className="sub-stat-card correct"><FontAwesomeIcon icon={faCheck} /><div className="stat-text"><h5>إجابات صحيحة</h5><span>{stats.correctAnswers}</span></div></div>
              <div className="sub-stat-card wrong"><FontAwesomeIcon icon={faTimes} /><div className="stat-text"><h5>إجابات خاطئة</h5><span>{stats.wrongAnswers}</span></div></div>
              <div className="sub-stat-card unanswered"><FontAwesomeIcon icon={faQuestion} /><div className="stat-text"><h5>لم يتم حلها</h5><span>{stats.notAnswered}</span></div></div>
            </div>
          </div>
          <div className="quick-nav-card">
            <h4>دوس على رقم السؤال عشان تشوفه</h4>
            <div className="questions-nav">
              {answer.map((q, index) => {
                const isNotAnswered = q.choosen === null || q.choosen === "0" || q.choosen === 0;
                return (
                  <button key={q.id} className={`nav-btn ${q.choosen === q.answer ? "correct" : !isNotAnswered ? "wrong" : ""}`} onClick={() => scrollToQuestion(q.id)}>
                    {index + 1}
                  </button>
                );
              })}
            </div>
          </div>
          <div className="questions-container">
            {answer.map((props, index) => {
              const isCorrect = props.choosen === props.answer;
              const isNotAnswered = props.choosen === null || props.choosen === "0" || props.choosen === 0;
              const isWrong = !isCorrect && !isNotAnswered;
              const cardStatusClass = isCorrect ? 'correct-card' : isWrong ? 'wrong-card' : 'unanswered-card';

              return (
                <div className={`question-card ${cardStatusClass}`} id={`question-${props.id}`} key={props.id}>
                  <div className="question-header">
                    <h4><img src="/images/problem.png" className="icon-question" alt="" loading="lazy" />السؤال رقم {index + 1}</h4>
                    <span className="degree-badge">{props.degree} درجات</span>
                  </div>
                  {isNotAnswered && props.type !== 'essay' && (
                    <div className="unanswered-alert">
                      <FontAwesomeIcon icon={faInfoCircle} />
                      <span>انت محلتش السؤال ده</span>
                    </div>
                  )}
                  <div className="question-body">
                  <div className="question-text" dangerouslySetInnerHTML={{ __html: props.question ? props.question.replace(/\r\n/g, '<br>').replace(/\n/g, '<br>') : '' }}></div>

                    {/* <p className="question-text">{props.question}</p> */}
                    {props.img && <img src={`${Image_URL}/storage/${props.img}`} className="question-image" alt="Question illustration" loading="lazy" />}
                  </div>
                  {props.type !== 'essay' && (
                    <div className="choices-container">
                      {props.c1 && renderChoice(props, "1", props.c1)}
                      {props.c2 && renderChoice(props, "2", props.c2)}
                      {props.c3 && renderChoice(props, "3", props.c3)}
                      {props.c4 && renderChoice(props, "4", props.c4)}
                    </div>
                  )}
                  {props.explain && (
                    <div className="explanation-box">
                      <h5><FontAwesomeIcon icon={faLightbulb} /> التفسير</h5>
                      <p>{props.explain}</p>
                      
                      {/* زر فيديو التفسير */}
                      {props.explain_url && (
                        <div className="explanation-video-section">
                          <a 
                            href={props.explain_url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="explanation-video-btn"
                          >
                            <FontAwesomeIcon icon={faQuestion} />
                            <span>فيديو تفسير السؤال</span>
                          </a>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </Container>
      </div>
      <ScrollTopButton />
    </>
  );
}

export default ModelAnswerQuiz;